module.exports = __webpack_public_path__ + "img/logo-web.cd014e03.png";